import { render, staticRenderFns } from "./StorageArtistsTab.vue?vue&type=template&id=d6a1dede&scoped=true&"
import script from "./StorageArtistsTab.vue?vue&type=script&lang=js&"
export * from "./StorageArtistsTab.vue?vue&type=script&lang=js&"
import style0 from "./StorageArtistsTab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StorageArtistsTab.vue?vue&type=style&index=1&id=d6a1dede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a1dede",
  null
  
)

export default component.exports